<template>
  <v-card>
    <v-card-title class="headline">
      <span>
        Delete selected RCTIs?
        <span class="grey--text subheading"></span>
      </span>
    </v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="grey darken-1" flat @click="close()">Cancel</v-btn>

      <v-btn color="red" flat @click="deleteRctis()" :loading="loading">Delete RCTIs</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import RctiService from "@/services/requests/rctiService";

export default {
  data() {
    return {
      loading: false
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    deleteRctis() {
      this.loading = true;
      var ids = this.selected.map(subject => {
        return subject.id;
      });
      RctiService.deleteRctis({ ids: ids })
        .then(result => {
          this.loading = false;
          for (var deleted of result.data.result) {
            this.$store.commit("rctis/deleteFromArrayStateById", {
              prop: "rctis",
              id: deleted
            });
          }
          this.snack({
            text: result.data.result.length + " RCTIs undone!",
            color: "green"
          });
          this.close();
        })
        .catch(err => {
          this.loading = false;
          this.snack({ text: err.response.data.message, color: "red" });
        });
    }
  },
  props: {
    selected: Array
  }
};
</script>